var _rect, _path, _path2, _path3, _path4, _ellipse, _ellipse2, _path5, _path6, _path7, _path8, _ellipse3, _path9, _ellipse4, _ellipse5, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicleMaster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 99,
    height: 99,
    rx: 11.5,
    fill: "#F8FBFF",
    stroke: "#EBF1FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.7273 69.2276L70.0455 39.6367L37.2728 40.9094L27.0909 69.2276H62.7273Z",
    fill: "#E5646E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4318 42.1816H69.0908L60.8181 69.068H81.9772L84.9999 58.0907L79.4318 53.9544V42.1816Z",
    fill: "#FFC269"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8636 44.4092H79.2727V53.1592H71L73.8636 44.4092Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9545 66.3634L70.8408 43.7725H68.4545L60.8181 69.227H79.909L80.8636 66.3634H64.9545Z",
    fill: "#FF8B5A"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.0348,
    cy: 67.6407,
    rx: 4.77273,
    ry: 5.09091,
    transform: "rotate(19.017 73.0348 67.6407)",
    fill: "#5D5360"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.909,
    cy: 67.6358,
    rx: 1.59091,
    ry: 1.59091,
    fill: "#262323"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 58.0908H28.2045",
    stroke: "#2E77D0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0681 62.2275H25.8181",
    stroke: "#2E77D0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7273 67.6357H24.3864",
    stroke: "#2E77D0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.25 69.0679L32.9773 54.2725H35.6818L31.0682 65.727H61.4545L60.3409 69.0679H27.25Z",
    fill: "#DB4655"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.1137,
    cy: 46.1588,
    rx: 12.8864,
    ry: 12.8864,
    fill: "#DB4655"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2727 44.8864C54.2727 51.7272 48.7272 57.2727 41.8864 57.2727C35.0456 57.2727 29.5 51.7272 29.5 44.8864C29.5 38.0456 35.0456 32.5 41.8864 32.5C48.7272 32.5 54.2727 38.0456 54.2727 44.8864Z",
    fill: "white",
    stroke: "#E5646E"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.2621,
    cy: 67.6407,
    rx: 4.77273,
    ry: 5.09091,
    transform: "rotate(19.017 40.2621 67.6407)",
    fill: "#5D5360"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.1363,
    cy: 67.6358,
    rx: 1.59091,
    ry: 1.59091,
    fill: "#262323"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2667 49.7077L46.169 49.7985C45.7481 50.1893 45.105 50.2208 44.6456 49.8762C44.2953 49.6135 43.8262 49.5653 43.4309 49.7536C43.0836 49.9189 42.839 50.2436 42.7758 50.623L42.7681 50.6691C42.6663 51.28 42.1377 51.7277 41.5184 51.7277H41.351C40.7189 51.7277 40.1804 51.269 40.0797 50.6451L40.0654 50.5563C40.0054 50.1843 39.7625 49.8674 39.4189 49.7128C39.054 49.5486 38.6291 49.5915 38.3043 49.8253L38.2653 49.8534C37.7731 50.2078 37.094 50.1407 36.6807 49.6967L36.5616 49.5688C36.1464 49.1228 36.0667 48.4597 36.3644 47.9281L36.4383 47.7962C36.5818 47.5399 36.6152 47.2362 36.5308 46.9548C36.4039 46.5318 36.0331 46.228 35.5934 46.1868L35.545 46.1823C34.9508 46.1265 34.4966 45.6278 34.4966 45.0309V44.4773C34.4966 43.8645 34.9529 43.3476 35.561 43.2716L35.7498 43.248C36.0987 43.2043 36.3916 42.9642 36.5028 42.6306C36.6024 42.3319 36.5411 42.003 36.3405 41.7602L36.2609 41.6638C35.878 41.2003 35.9214 40.519 36.36 40.1078L36.7018 39.7873C37.1173 39.3977 37.7409 39.3312 38.2292 39.6242C38.6029 39.8484 39.0652 39.8661 39.4549 39.6713L39.6372 39.5801C39.9161 39.4407 40.1075 39.1717 40.1478 38.8625C40.2088 38.3954 40.6068 38.0459 41.0779 38.0459H41.5579C42.1544 38.0459 42.6635 38.4772 42.7616 39.0656L42.7709 39.1213C42.8364 39.5145 43.1056 39.8433 43.4781 39.9852C43.8475 40.126 44.2638 40.0618 44.5737 39.8165L44.5957 39.7991C45.0738 39.4205 45.7625 39.4724 46.1786 39.9182L46.3292 40.0795C46.7508 40.5313 46.8293 41.205 46.5226 41.7416L46.4193 41.9224C46.2368 42.2419 46.2305 42.6326 46.4026 42.9578C46.5525 43.2408 46.8207 43.4422 47.1343 43.507L47.2448 43.5299C47.8549 43.6561 48.2924 44.1935 48.2924 44.8165V45.0428C48.2924 45.6344 47.8452 46.1302 47.2567 46.1911C46.8712 46.231 46.5313 46.4617 46.352 46.8054L46.2961 46.9125C46.088 47.3115 46.1289 47.7948 46.4012 48.1531C46.7627 48.6288 46.7046 49.3012 46.2667 49.7077Z",
    fill: "#4E93E9",
    stroke: "#246CAF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1177 44.887C43.1177 45.8073 42.3717 46.5533 41.4514 46.5533C40.5312 46.5533 39.7852 45.8073 39.7852 44.887C39.7852 43.9667 40.5312 43.2207 41.4514 43.2207C42.3717 43.2207 43.1177 43.9667 43.1177 44.887Z",
    fill: "#FFC269",
    stroke: "#246CAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleMaster);
export default __webpack_public_path__ + "static/media/vehicle-master.9a534509f76a0c4746f46b43dbd343db.svg";
export { ForwardRef as ReactComponent };